import React, { createContext, useEffect, useState } from "react"
import { useLocation } from 'react-router-dom'

const LayoutContext = createContext()
const minSidebarCollapseWidth = 600

export const LayoutContextProvider = ( { children } ) => {

    const { pathname } = useLocation()

    const [menuState, setMenuState] = useState( window.innerWidth < minSidebarCollapseWidth ? false : true )
    const [isSideDrawerCollapsed, setIsSideDrawerCollapsed] = useState( localStorage.getItem( 'isSideDrawerCollapsed' ) === 'true' ?? false )
    const [sidebarWidth, setSidebarWidth] = useState( 280 )
    const [navHeight, setNavHeight] = useState( 60 )
    const [focusedMenuItem, setFocusedMenuItem] = useState( null )
    const [secondarySidebarStatus, setSecondarySidebarStatus] = useState( false )
    const [sidebarOpenState, setSidebarOpenState] = useState( false )
    const [navHeadText, setNavHeadText] = useState( "" )

    const value = {
        minSidebarCollapseWidth: minSidebarCollapseWidth,
        secondarySidebarStatus,
        isSideDrawerCollapsed,
        sidebarOpenState,
        active: pathname,
        focusedMenuItem,
        sidebarWidth,
        navHeadText,
        menuState,
        navHeight,

        setSecondarySidebarStatus,
        setIsSideDrawerCollapsed,
        setSidebarOpenState,
        setFocusedMenuItem,
        setSidebarWidth,
        setNavHeadText,
        setMenuState,
        setNavHeight,
    }

    useEffect( () => {
        localStorage.setItem( 'isSideDrawerCollapsed', isSideDrawerCollapsed )
    }, [isSideDrawerCollapsed] )

    return (
        <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>
    )
}

/* Hook to use store in any functional component */
export const useLayoutContext = () => React.useContext( LayoutContext )

export default LayoutContextProvider
